import * as React from "react";
import { Link } from "react-router-dom";
import { BreadcrumbTemplateEnum, breadcrumbTemplates } from "./breadcrumbTemplates";
import { JSX } from "react";

interface BreadcrumbsProps {
  items: Array<string | Breadcrumb>;
  template?: BreadcrumbTemplateEnum;
}

export interface Breadcrumb {
  iconClass?: string;
  link?: string;
  text: string;
}

const renderBreadcrumb = (item: string | Breadcrumb, index: number, items: Breadcrumb[]) => {
  switch (typeof item) {
    case "string":
      return (
        <li key={`${item}-${index}`} className="breadcrumb-item">
          {item}
        </li>
      );
    case "object":
      const result: JSX.Element[] = [];
      let icon: JSX.Element = null;
      if (item.iconClass) {
        icon = <i key="crumb-item" className={`fa ${item.iconClass} mr-1`} />;
      }
      if (item.link && index !== items.length - 1) {
        result.push(<Link key={`crumb-${index}`} to={item.link}>{icon}{item.text}</Link>);
      } else {
        result.push(<span key={`crumb-${index}`}>{icon}{item.text}</span>);
      }
      return (
        <li key={`${item.text}-${index}`} className="breadcrumb-item">
          {result}
        </li>
      );
  }
};

const Breadcrumbs: React.FunctionComponent<React.PropsWithChildren<BreadcrumbsProps>> = (props: BreadcrumbsProps) => {
  const template = breadcrumbTemplates[props.template];
  const breadcrumbItems = [...props.items];
  if (template) {
    breadcrumbItems.unshift(...template);
  }
  return (
    <>
      {
        !!props.items && (
          <nav className="page-navs">
            <div className="row w-100">
              <div className="col-md-12">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={"/"}><i className="fa fa-home mr-1" />Home</Link>
                  </li>
                  {breadcrumbItems.map(renderBreadcrumb)}
                </ol>
              </div>
            </div>
          </nav>
        )
      }
    </>
  );
};

export default Breadcrumbs;
